import { safeRandomUUID } from '@zep/utils/common/safeRandomUUID';

import { AI_MAP_SESSION_ID_PATTERN } from './aiMap.constants';

export const TEMPLATE_CREATE_PATH = '/home/create';
export const AI_MAP_CREATE_PATH = `${TEMPLATE_CREATE_PATH}/ai`;

// The session id rides in the query, not the path, so the page stays a
// build-time static asset: every id is freshly minted, so a dynamic route
// would miss the ISR cache and server-render on each entry.
export const AI_MAP_SESSION_QUERY_KEY = 'session';

export const aiMapSessionPath = (sessionId: string) =>
  `${AI_MAP_CREATE_PATH}?${AI_MAP_SESSION_QUERY_KEY}=${encodeURIComponent(
    sessionId,
  )}`;

// Entry points mint the session themselves so navigation lands on a ready URL
// instead of bouncing through an id-less route that only renders a skeleton.
export const newAiMapSessionPath = () => aiMapSessionPath(safeRandomUUID());

export const isValidAiMapSessionId = (value: unknown): value is string =>
  typeof value === 'string' && AI_MAP_SESSION_ID_PATTERN.test(value);
